import React from "react";

/**
 * Source quality banner (Step 3). Renders only when the AI-self-assessed
 * source quality score is below 70 (else the parent simply skips it).
 *
 * Two severity levels:
 *   - 50 ≤ score < 70 → brand-orange "eingeschränkt"
 *   - score < 50      → pause-red "niedrig — besonders sorgfältig prüfen"
 */
export default function QualityBanner({ quality, onOpenCompare }) {
  const score = quality?.score ?? 100;
  const isCritical = score < 50;
  const palette = isCritical
    ? "border-status-pause-border bg-status-pause-bg text-ink-900"
    : "border-brand-300 bg-brand-100/40 text-ink-900";
  const dot = isCritical ? "bg-status-pause-border" : "bg-brand-500";
  const title = isCritical
    ? "Quellenqualität niedrig — bitte besonders sorgfältig prüfen"
    : "Quellenqualität eingeschränkt — bitte Extraktion prüfen";
  return (
    <div
      data-testid="tool-step3-quality-banner"
      className={`border ${palette} rounded-sm p-4 text-sm flex gap-3 items-start`}
    >
      <span
        aria-hidden="true"
        className={`mt-1 inline-block h-2 w-2 rounded-full ${dot} shrink-0`}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[10px] uppercase tracking-widest font-semibold text-warm-500">
            Quellenqualität
          </span>
          <span
            data-testid="tool-step3-quality-score"
            className="text-[11px] font-semibold tabular-nums text-ink-700"
          >
            {score} / 100
          </span>
        </div>
        <div className="font-medium mt-1 leading-snug">{title}</div>
        {quality.kommentar && (
          <div className="text-[13px] text-warm-700 mt-1 leading-relaxed">
            {quality.kommentar}
          </div>
        )}
        {onOpenCompare && (
          <button
            type="button"
            onClick={onOpenCompare}
            data-testid="tool-step3-quality-open-compare"
            className="mt-2 inline-flex items-center gap-1 text-[12px] font-semibold uppercase tracking-wider text-brand-700 hover:text-brand-800 underline underline-offset-2"
          >
            Quelle prüfen
          </button>
        )}
      </div>
    </div>
  );
}
